/* @flow */

import { tablet, lap } from '@e180/ui/lib/token/mediaQuery';

export default {
  root: {
    display: 'none',

    maxWidth: 142,

    [tablet]: {
      display: 'block',

      marginLeft: 16,
    },
    [lap]: {
      marginLeft: 66,
    },
  },
};
